import { SyntheticEvent, useRef } from 'react';
import { CSSProperties } from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { IChannel, IFormattedChannelTheme } from '@r1-frontend/ui-react/components/Channels/types';
import { SearchInput } from '@r1-frontend/ui-react/components/input/search';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Select, { IOption } from '@r1-frontend/ui-react/components/select/select';
import { SearchNormal } from '@r1-frontend/ui-react/components/svg/search';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

export interface IChannelsFiltersProps {
    isShowSearch: boolean,
    channels: IChannel[],
    selectedFilter: IFormattedChannelTheme,
    preparedThemes: IFormattedChannelTheme[],
    onChangeChannelTheme: (value: IOption<any>) => void,
    onShowSearchInput: (e: SyntheticEvent) => void,
    onClearSearch: () => void,
    onChangeSearch: (e: any) => void,
    value: string,
}

const ChannelsFilters = ({
    isShowSearch,
    channels,
    selectedFilter,
    preparedThemes,
    onChangeChannelTheme,
    onShowSearchInput,
    onClearSearch,
    onChangeSearch,
    value,
}: IChannelsFiltersProps): JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);
    const searchRef = useRef<HTMLInputElement>(null);

    return (
        <ST.Wrapper data-test='channels-filters'>
            {!isShowSearch
                    ? <ST.ChannelsSelector>
                        <Select
                            options={preparedThemes}
                            value={selectedFilter.value === 0 && preparedThemes?.length
                                ? preparedThemes[0]
                                : selectedFilter
                            }
                            onChange={onChangeChannelTheme}
                            width={'100%'}
                            maxMenuHeight={300}
                            placeholder={'Все каналы'}
                            noOptionsMessage={'Нет категорий'}
                            data-test='channels-filters-themes'
                            isDisabled={!preparedThemes?.length}
                            styles={{
                                singleValue: (provided: CSSProperties): CSSProperties => ({
                                    ...provided,
                                    color: COLORS.Disabled,
                                }),
                            }}
                        />
                        <Button
                            Icon={<SearchNormal/>}
                            size={'large'}
                            bType={'secondary'}
                            disabled={!preparedThemes?.length}
                            rounded={!isMobile}
                            onClick={(e: SyntheticEvent) => onShowSearchInput(e)}
                            data-test='channels-filters-open-search-button'
                        >
                            {isMobile ? 'Поиск' : null}
                        </Button>
                    </ST.ChannelsSelector>
                    : <ST.FiltersSearch>
                        <SearchInput
                            ref={searchRef}
                            placeholder='Найдите канал'
                            items={channels}
                            onClear={onClearSearch}
                            value={value}
                            onChange={onChangeSearch}
                            onClick={(e: SyntheticEvent) => e.stopPropagation()}
                            isClearBtnHide={!value}
                            data-test='channels-filters-search-input'
                        />
                    </ST.FiltersSearch>
            }
        </ST.Wrapper>
    );
};

export default ChannelsFilters;
